import { compareModels, type CatalogModel } from "./model";

// Curated discovery order, not a measured usage ranking. Only models present in the catalog appear.
const FEATURED_MODELS = [
  "moonshotai/kimi-k3",
  "deepseek-ai/deepseek-v4.1-flash",
  "qwen/qwen3.8-27b",
  "openai/gpt-oss-120b",
  "google/gemma-4-31b-it",
  "zai-org/glm-5.3",
  "deepseek-ai/deepseek-v4-pro",
  "openai/gpt-oss-20b",
  "meta-llama/llama-3.3-70b-instruct",
  "mistralai/mistral-medium-3-5",
  "google/gemma-4-26b-a4b-it",
  "zai-org/glm-5.3-flash",
];
const priority = new Map(FEATURED_MODELS.map((id, index) => [id, index]));

/** The discovery grid features familiar models first, then retains the catalog's stable ordering. */
export function compareCatalogModels(a: CatalogModel, b: CatalogModel): number {
  return (priority.get(a.id) ?? FEATURED_MODELS.length) - (priority.get(b.id) ?? FEATURED_MODELS.length)
    || compareModels(a, b);
}
